"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Rotating Crop Ratios',
  description: "Crop each image according to the corresponding crop ratio as indicated in this string. This will create a pattern of cropped images",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.cubeImages;
  },
  type: _constants.INPUT_TYPES.TEXT,
  "default": ''
};
exports["default"] = _default;